module.exports = __webpack_public_path__ + "img/blue_house.0246e1a3.svg";